import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BackendConfiguration} from '@application/configuration/backend-configuration';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {DownloadUrls} from './download-urls';

@Injectable()
export class HttpDownloadUrlsService implements DownloadUrls {
  private readonly httpClient: HttpClient;
  private readonly backendConfiguration: BackendConfiguration;
  private authEndpoint: string;

  public constructor(httpClient: HttpClient, backendConfiguration: BackendConfiguration) {
    this.httpClient = httpClient;
    this.backendConfiguration = backendConfiguration;
    this.authEndpoint = this.backendConfiguration.getAuthenticationEndpoint();
  }

  public getTuftLinkDownloadUrl(): Observable<string> {
    const url = `${this.authEndpoint}vdwuser/external-application/tuftlink/download-url`;
    return this.getDownloadUrl(url);
  }

  private getDownloadUrl(url: string): Observable<string> {
    return this.httpClient.get(url).pipe(map((response: {downloadUrl: string}) => response.downloadUrl));
  }
}
